import { render, staticRenderFns } from "./BlwTextArea.vue?vue&type=template&id=3b9a5b70&"
import script from "./BlwTextArea.vue?vue&type=script&lang=js&"
export * from "./BlwTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports